import { db } from "../../server";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { DetectBrand } from "../../mixins/brandDetector";
import { instance } from "../apiclient";

export function getTrackingOrder(userId, orderId, storeId) {
  if (DetectBrand.methods.isBranded()) {
    return db.doc(interpolate(paths.TrackingOrderDoc, userId, orderId));
  } else {
    return db.doc(interpolate(paths.TrackingOrderDoc, storeId, orderId));
  }
}

export function getOrderHistory(userId, orderId, storeId) {
  if (DetectBrand.methods.isBranded()) {
    return db.doc(interpolate(paths.OrderHistoryDoc, userId, orderId));
  } else {
    return db.doc(interpolate(paths.OrderHistoryDoc, storeId, orderId));
  }
}

export function cancelOrder(order, ScheduledTime) {
  var data = {
    StoreID: order.StoreID, //"2016949",
    OnlineOrderUserIdentifier: order.OnlineOrderUserIdentifier,
    Source: order.Source,
    SourceReference_ID: order.SourceReference_ID,
    SourceReferenceNumber: order.SourceReferenceNumber,
    OrderNumber: order.OrderNumber,
    DisplayName: "",
    ScheduledTime: ScheduledTime,
  };
  var status = 12;
  return instance.put(`trackingorders/${order.UDID}/status/${status}`, data);
}
